const handleReopenActionFormActions = {
  confirm: 'Do you really want to reopen this action?',
  title: 'REOPEN ACTION',
  newStatus: 'In progress'
};

export default handleReopenActionFormActions;
